import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function YearExperience({ member }) {
  return (

    <ValueItem
      icon="years-experience-icon"
      label="Years of Experience"
    >
      {member.years_experience}
    </ValueItem>
  );
}

YearExperience.propTypes = {
  member: PropTypes.object.isRequired,
};
